import React from 'react';
import PropTypes from 'prop-types';

export function EmptyBlock(props) {
  return <div className={props.className} />;
}

EmptyBlock.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

EmptyBlock.defaultProps = {
  className: '',
};
